import { AboutYourCarForm } from "./Form";
import useAboutYourCar from "./hooks";

export const AboutYourCar = () => {
  const props = useAboutYourCar();
  return <AboutYourCarForm {...props} />;
};

export default AboutYourCar;
